"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countBookingChildrenUnderSeven = exports.countBookingChildren = exports.countBookingPeople = void 0;
const countBookingPeople = (people, Instructors) => {
    return Object.keys(people || {}).reduce((sum, customId) => sum + (people[customId] || 0), 0) + (Instructors !== undefined ?
        (typeof Instructors === 'number' ?
            0 : Instructors.length)
        : 0);
};
exports.countBookingPeople = countBookingPeople;
const countBookingChildren = (prices, people) => {
    const childCustomIds = prices.reduce((ids, price) => {
        if (price.isChild) {
            ids.push(price.customId);
        }
        return ids;
    }, []);
    return Object.keys(people)
        .filter((customId) => childCustomIds.includes(customId))
        .reduce((sum, customId) => sum + people[customId], 0);
};
exports.countBookingChildren = countBookingChildren;
const countBookingChildrenUnderSeven = (prices, people) => {
    const childCustomIds = prices.reduce((ids, price) => {
        if (price.isChildUnderSeven) {
            ids.push(price.customId);
        }
        return ids;
    }, []);
    return Object.keys(people)
        .filter((customId) => childCustomIds.includes(customId))
        .reduce((sum, customId) => sum + people[customId], 0);
};
exports.countBookingChildrenUnderSeven = countBookingChildrenUnderSeven;
//# sourceMappingURL=countBookingPeople.js.map